(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minus30-clearance-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('clearance-countdown')) {
  customElements.define('clearance-countdown', class extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.deadline);
      if (!Number.isFinite(this.deadline)) return;
      this.tick();
      if (this.deadline > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    tick() {
      const total = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
      const expired = total === 0;
      this.querySelector('.m30-sale__clock').hidden = expired;
      this.querySelector('.m30-sale__button').hidden = expired;
      this.querySelector('.m30-sale__ended').hidden = !expired;
      const values = {days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60};
      Object.entries(values).forEach(([key, value]) => { this.querySelector('[data-' + key + ']').textContent = String(value).padStart(2, '0'); });
      if (expired) clearInterval(this.interval);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-blackout"] && !Shopify.designMode) return;
  try {
    
(() => {
  const key = 'minus30-blackout-dismissed';
  const subscribedKey = 'minus30-blackout-subscribed';
  const init = () => document.querySelectorAll('[data-pb-root]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('[data-pb-dialog]');
    const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
    const write = (key,value) => { try { localStorage.setItem(key,value); } catch {} };
    root.querySelectorAll('.pb-form').forEach(form => {
      const tagInput = form.querySelector('[data-pb-tags]');
      const baseTags = tagInput.value;
      form.addEventListener('submit', () => {
        const style = form.querySelector('[data-pb-style]')?.value;
        const size = form.querySelector('[data-pb-size]')?.value;
        tagInput.value = [baseTags,style && 'blackout-interest-'+style,size && 'blackout-size-'+size].filter(Boolean).join(',');
      });
    });
    if (root.querySelector('[data-pb-success]')) write(subscribedKey,'1');
    if (!dialog) return;
    root.querySelectorAll('[data-pb-open]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();dialog.showModal();}));
    root.querySelector('[data-pb-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('close',()=>write(key,String(Date.now())));
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    const result = dialog.querySelector('[data-pb-success],[role=alert]');
    if (result) { dialog.showModal(); return; }
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:block:select', event => { if (event.target === dialog || dialog.contains(event.target)) { if (!dialog.open) dialog.showModal(); } });
      document.addEventListener('shopify:block:deselect', event => { if (event.target === dialog || dialog.contains(event.target)) dialog.close(); });
      return;
    }
    const due = () => !read(subscribedKey) && Date.now()-Number(read(key)||0)>7*24*60*60*1000;
    let timerReady = false;
    const tryOpen = () => {
      const emailActive = document.activeElement?.closest('form');
      const signup = root.querySelector('#blackout-signup');
      const rect = signup?.getBoundingClientRect();
      const signupVisible = rect && rect.top < innerHeight && rect.bottom > 0;
      if(timerReady&&due()&&!emailActive&&!signupVisible&&!document.querySelector('dialog[open]')&&!document.hidden)dialog.showModal();
    };
    window.setTimeout(()=>{timerReady=true;tryOpen();},12000);
    document.addEventListener('visibilitychange',tryOpen);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
